export const stepIds = {
  title: 'editTitle',
  basicDetails: 'editBasicDetails'
} as const;

export type StepIds = (typeof stepIds)[keyof typeof stepIds];
